module.exports = __webpack_public_path__ + "static/media/sincronizar.a2930d70.png";